import { Link } from "react-router-dom";
import { SectionHead } from "../components/Motion";

const TERMS = [
  ["Orders & Payment", "All Savyron orders are prepaid. We accept secure online payments via UPI, cards and net banking. Cash on Delivery is not available. We never store your card number, CVV, OTP or UPI PIN."],
  ["Delivery", "Estimated delivery is 2–4 business days to serviceable pincodes, shown by the pincode checker on each product page. Estimates are not guarantees."],
  ["Returns & Exchange", "We do not offer returns. Exchange is available only on products marked exchange-eligible, for damaged, defective, wrong or missing items. Write to founder@savyron.in with your order number and photos."],
  ["Coming Soon Products", "Products marked Coming Soon are not available for purchase. The Notify Me feature only registers your interest."],
  ["Contest", "Contest entries require accurate details. Any prize, deadline or selection detail is valid only as stated on the contest section at the time of entry."],
  ["Contact", "SAVYRON · founder@savyron.in · Plot No. 87, Sector 62, Noida – 201309 · Instagram @savyron.in"],
];

const PRIVACY = [
  ["What We Collect", "Your name, email, mobile number, delivery addresses, order details and contest entries — only what is needed to fulfil your orders and improve your experience."],
  ["What We Never Store", "Card numbers, CVV, OTPs, UPI PINs or any payment credentials. Payments are processed entirely by our payment gateway."],
  ["How We Use It", "To process orders, send order confirmations, respond to support requests and — only if you opt in — notify you about launches."],
  ["Your Control", "You may update your profile and addresses anytime from My Account, or request account deletion by writing to founder@savyron.in."],
  ["Security", "Passwords are stored only as secure hashes. Sessions are protected and invalidated on logout."],
];

export default function Legal({ kind }) {
  const isTerms = kind === "terms";
  const sections = isTerms ? TERMS : PRIVACY;
  return (
    <div className="pt-28 pb-24 max-w-3xl mx-auto px-4 sm:px-6 min-h-screen" data-testid={`${kind}-page`}>
      <SectionHead overline="Savyron" title={isTerms ? "Terms of Service" : "Privacy Policy"} center />
      <div className="space-y-4">
        {sections.map(([t, body]) => (
          <div key={t} className="card-surface rounded-2xl p-6">
            <h3 className="font-serif-lux text-xl text-[#2E1A22] mb-2">{t}</h3>
            <p className="text-sm text-[#857078] leading-relaxed">{body}</p>
          </div>
        ))}
      </div>
      <p className="text-center text-sm text-[#857078] mt-10">
        Questions? <a href="mailto:founder@savyron.in" className="text-[#7E1E3F] underline">founder@savyron.in</a> · <Link to="/" className="text-[#7E1E3F] underline">Back to Savyron</Link>
      </p>
    </div>
  );
}
